import { useEffect, useState } from 'react'
import { authedAxios } from '../../utils'

const useTaskStatusTypes = () => {
  const [taskStatusTypes, setTaskStatusTypes] = useState([])
  const [loading, setLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  const getTaskStatusTypes = () => {
    setHasError(false)
    authedAxios
      .get('/api/task/status-types')
      .then((res) => {
        setTaskStatusTypes(res.data.types)
      })
      .catch(() => setError(true))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    getTaskStatusTypes()
  }, [])

  return { taskStatusTypes, setTaskStatusTypes, loading, hasError }
}

export default useTaskStatusTypes
